import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { GET_SHOPIFY_SALES_QUERY } from './useGetOrders'

type CreateShopifySalesPayload = {
  visitor: number
  shopify_order_id: number
}

export const useCreateShopifySales = () => {
  const queryClient = useQueryClient()
  const { mutate: notifyError } = useNotifyError()
  return useMutation({
    mutationKey: ['create-shopify-sale'],
    mutationFn: async (payload: CreateShopifySalesPayload) => {
      const { error } = await supabaseApi.from('shopify_sales').insert(payload)

      if (error) {
        console.error(error)

        notifyError({
          data: { payload },
          function: 'useCreateShopifySales',
          message: error.message,
          error,
        })
        toast.error('Visitor and shopify sales connection failed. Check console.')
        throw error
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_SHOPIFY_SALES_QUERY] })
    },
  })
}
